import { combineReducers } from '@ngrx/store';
import * as fromOrderCreation from './adt-summary-reducers/order-creation.reducer';

/**
 * Interface of all the States used for Adt Summary
 */
export interface AdtSummaryState {
    orderCreationState: fromOrderCreation.OrderCreationState;
}

/**
 * Adt Summary reducer combinaded
 */
export const adtSummaryReducers = combineReducers({
    orderCreationState: fromOrderCreation.adtOrderCreationReducer,
});
